import { Grid, Typography } from '@mui/material';

import { AssignmentCard, ClientSummarySection, InsurancePolicyCard } from './components';
import { useFetchTreatmentPlanV3InformationPage, useTreatmentPlanV3Information } from './hooks';
import { TreatmentPlanV3PageContent, TreatmentPlanV3PageLoadState } from '../components';
import { TREATMENT_PLAN_V3_SECTION_HEADING_SX } from '../../../styles';

export default function InformationForm() {
  const { retry } = useFetchTreatmentPlanV3InformationPage();
  const {
    client,
    insurance,
    btEntries,
    bcbaEntries,
    parentGuardianEntries,
    parentGuardianLoadFailed,
    hasLoaded,
    hasLoadError,
  } = useTreatmentPlanV3Information();

  return (
    <TreatmentPlanV3PageContent title="Information">
      <TreatmentPlanV3PageLoadState
        errorMessage="Unable to load client information. Please try again."
        hasLoaded={hasLoaded}
        hasLoadError={hasLoadError}
        onRetry={retry}
      >
        <ClientSummarySection client={client} />

        <Typography variant="h5" sx={TREATMENT_PLAN_V3_SECTION_HEADING_SX}>
          Insurance
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <InsurancePolicyCard title="Primary" policy={insurance?.primary ?? null} />
          </Grid>
          <Grid item xs={12} md={4}>
            <InsurancePolicyCard title="Secondary" policy={insurance?.secondary ?? null} />
          </Grid>
          <Grid item xs={12} md={4}>
            <InsurancePolicyCard title="Tertiary" policy={insurance?.tertiary ?? null} />
          </Grid>
        </Grid>

        <Typography variant="h5" sx={TREATMENT_PLAN_V3_SECTION_HEADING_SX}>
          Assignment
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <AssignmentCard
              emptyMessage="No parents/guardians assigned"
              entries={parentGuardianEntries}
              errorMessage={
                parentGuardianLoadFailed
                  ? 'Unable to load parents and guardians for this client.'
                  : undefined
              }
              title="Parent/guardian"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <AssignmentCard emptyMessage="No BTs assigned" entries={btEntries} title="BT(s)" />
          </Grid>
          <Grid item xs={12} md={4}>
            <AssignmentCard
              emptyMessage="No BCBAs assigned"
              entries={bcbaEntries}
              title="BCBA(s)"
            />
          </Grid>
        </Grid>
      </TreatmentPlanV3PageLoadState>
    </TreatmentPlanV3PageContent>
  );
}
